export enum IndicatorQuestionResponseValues {
  almostNever = 0,
  rarely = 1,
  sometimes = 2,
  quiteOften = 3,
  almostAlways = 4
}
